document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var cartClosers = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  cartOpeners.forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  cartClosers.forEach(function (el) { el.addEventListener('click', closeCart); });

  /* ---------- Cart drawer rendering ---------- */
  function escapeHtml(str) {
    return (str || '').toString()
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    return 'Rs.' + (cents / 100).toFixed(2);
  }

  function resizeImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function cartItemHtml(item) {
    var imageHtml = item.image
      ? '<img src="' + resizeImage(item.image, 200) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="64" height="64">'
      : '';
    var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</div>'
      : '';
    return (
      '<div class="cart-drawer__item" data-cart-item data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cart-drawer__item-media">' + imageHtml + '</a>' +
        '<div class="cart-drawer__item-info">' +
          '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
          variantHtml +
          '<div class="cart-drawer__item-price">' + formatMoney(item.final_price) + '</div>' +
          '<div class="cart-drawer__item-qty" data-cart-qty data-key="' + item.key + '">' +
            '<button type="button" data-qty-decrease aria-label="Decrease quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg></button>' +
            '<span data-qty-value>' + item.quantity + '</span>' +
            '<button type="button" data-qty-increase aria-label="Increase quantity"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cart-drawer__item-remove" data-cart-remove data-key="' + item.key + '" aria-label="Remove item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="4" y1="4" x2="20" y2="20"/><line x1="20" y1="4" x2="4" y2="20"/></svg></button>' +
      '</div>'
    );
  }

  function renderCartDrawer(cart) {
    if (!cartDrawer) return;
    var body = cartDrawer.querySelector('[data-cart-drawer-body]');
    var footer = cartDrawer.querySelector('[data-cart-drawer-footer]');
    var subtotalEl = cartDrawer.querySelector('[data-cart-drawer-subtotal]');

    if (!body) return;

    if (cart.item_count > 0) {
      body.innerHTML = cart.items.map(cartItemHtml).join('');
      if (footer) footer.style.display = '';
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    } else {
      body.innerHTML = '<p class="cart-drawer__empty" data-cart-empty>Your cart is currently empty.</p>';
      if (footer) footer.style.display = 'none';
    }

    var countEls = document.querySelectorAll('.cart-count');
    countEls.forEach(function (el) { el.textContent = cart.item_count; });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (res) { return res.json(); });
  }

  function changeLineQuantity(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCartDrawer(cart); })
      .catch(function () {});
  }

  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      var qtyWrap = e.target.closest('[data-cart-qty]');
      var removeBtn = e.target.closest('[data-cart-remove]');

      if (qtyWrap) {
        var key = qtyWrap.getAttribute('data-key');
        var span = qtyWrap.querySelector('[data-qty-value]');
        var current = span ? (parseInt(span.textContent, 10) || 1) : 1;

        if (e.target.closest('[data-qty-increase]')) {
          changeLineQuantity(key, current + 1);
        } else if (e.target.closest('[data-qty-decrease]')) {
          changeLineQuantity(key, current - 1 < 0 ? 0 : current - 1);
        }
      }

      if (removeBtn) {
        changeLineQuantity(removeBtn.getAttribute('data-key'), 0);
      }
    });

    /* Sync the drawer with the real cart on first paint (handles cache, other-tab changes, etc.) */
    fetchCart().then(renderCartDrawer);
  }

  /* ---------- Mobile nav ---------- */
  var mobileNav = document.getElementById('mobile-nav');
  var burger = document.querySelector('[data-mobile-nav-open]');
  var mobileClosers = document.querySelectorAll('[data-mobile-nav-close]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      mobileNav.setAttribute('aria-hidden', 'false');
    });
  }
  mobileClosers.forEach(function (el) {
    el.addEventListener('click', function () { mobileNav.setAttribute('aria-hidden', 'true'); });
  });

  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.mobile-nav__group');
      if (!group) return;
      group.classList.toggle('is-open');
    });
  });

  /* ---------- Add to cart (AJAX) ---------- */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var btn = form.querySelector('[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () { return fetchCart(); })
        .then(function (cart) {
          renderCartDrawer(cart);
          if (btn) { btn.textContent = 'Added ✓'; }
          openCart();
          setTimeout(function () {
            if (btn) { btn.textContent = originalText; btn.disabled = false; }
          }, 1500);
        })
        .catch(function () {
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
        });
    });
  });

  /* ---------- Wishlist toggle (visual only) ---------- */
  document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      btn.classList.toggle('is-active');
    });
  });

  /* ---------- Carousel controls ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (!track) return;
    function scrollAmount() {
      var card = track.querySelector(':scope > *');
      return card ? card.getBoundingClientRect().width + 20 : 300;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
  });

});
